<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_account_details)">
            <path d="M10.0004 12.4266C12.6898 12.4266 14.87 10.2465 14.87 7.55707C14.87 4.86768 12.6898 2.6875 10.0004 2.6875C7.31104 2.6875 5.13086 4.86768 5.13086 7.55707C5.13086 10.2465 7.31104 12.4266 10.0004 12.4266Z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.69531 16.6867C4.16912 14.14 6.84586 12.4258 9.99966 12.4258C13.1535 12.4258 15.8302 14.14 17.304 16.6867" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_account_details">
                <rect width="20" height="20" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>
